import Button from "../../Core/Button/Button";
import printerimg from "../../assets/print.png"


const ButtonShowcase = () => {
  const handleAddRow = () => console.log('Add row clicked');
  const handleDelete = () => console.log('Delete clicked');
  const po_response = { result: false };

  return (
    <div className="container py-4">
      <h2 className="mb-4">Button Component Showcase</h2>
      
      <div className="row mb-5">
        <div className="col-12">
          <h4>Basic Buttons</h4>
          <div className="d-flex flex-wrap gap-3 mb-4">
            <Button className="custom-btn-00989blue">
              Primary Button
            </Button>
            <Button className="custom-btn-bluecolor">
              Secondary Button
            </Button>
            <Button className="createbtn">
              Create Button
            </Button>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-12">
          <h4>Buttons with Icons</h4>
          <div className="d-flex flex-wrap gap-3 mb-4">
            <Button 
            style={{gap:'2px'}}
              className="custom-btn-bluecolor"
              iconName="BiCloudUpload"
              iconSize={14}
            >
              Upload
            </Button>
            
            <Button 
            style={{gap:'2px'}}
              className="createbtn"
              iconName="GrCopy"
              iconSize={12}
            >
              Duplicate
            </Button>
            
            <Button 
            style={{gap:'2px'}}
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              iconSize={12}
            >
              {po_response.result ? 'Submit' : 'Save'}
            </Button>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-12">
          <h4>Special Buttons</h4>
          <div className="d-flex flex-wrap gap-3 mb-4">
            <Button 
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px' }}
            >
              Add Row
            </Button>
            
            <Button 
              onClick={handleDelete}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
            
            <Button 
              className="importbtn"
              style={{ backgroundColor: '#fff', height: '28px' }}
              iconName="IoMdArrowDropdown"
              iconSize={14}
              iconPosition="right"
              iconBoxClassName="ps-2"
              text="Last Updated On"
            />
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-12">
          <h4>Navigation & Image Buttons</h4>
          <div className="d-flex flex-wrap gap-3 mb-4">
            <Button 
              to="/some-path" 
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
            
            <Button 
              to="/inbound/grn/create-purchase-receipt" 
              state={po_response.result} 
              style={{ backgroundColor: '#fff' }} 
              className="custom-btn-00989blue"
            >
              + Create GRN
            </Button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h4>Button States</h4>
          <div className="d-flex flex-wrap gap-3 mb-4">
            <Button disabled className="custom-btn-00989blue">
              Disabled Button
            </Button>
            
            <Button 
              style={{ display: 'none' }} 
              className="custom-btn-bluecolor"
            >
              Hidden Button
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonShowcase;